/*
 *
 *  * Copyright (c) Funtip GbR 2018.
 *  * Simon Oldeboershuis, Perry Prust
 *
 */

import moment from 'moment';
import { all, takeEvery } from 'redux-saga/effects';
import { Action } from 'typescript-fsa';
import { fetchWrapperFunc } from '../../../utils';
import { getPlaylistAdminApi, getSystemConfig } from '../../System/systemConfig';
import { REFRESH_SONG_MAIN_ALBUM_ID } from './actions';

const STATION_ID: string = getSystemConfig().playlistStationId;

const playlistApi = getPlaylistAdminApi();

function* refreshSongMainAlbumIdGenerator(action: Action<Date>) {
    yield* fetchWrapperFunc(() =>
        playlistApi.refreshMainAlbumIds(STATION_ID, moment(action.payload).format('YYYY-MM-DD'))
    );
}

function* watchForRefreshSongMainAlbumId() {
    yield takeEvery(REFRESH_SONG_MAIN_ALBUM_ID, refreshSongMainAlbumIdGenerator);
}

export function* playlistMaintenanceSagas() {
    yield all([watchForRefreshSongMainAlbumId()]);
}
